import SectionHeading from "./SectionHeading";
import { timeline } from "./data";

export default function NewsTimeline() {
  return (
    <section id="news" className="scroll-mt-24 border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="官方快讯 · 动态时间线"
          title="官网动态与安全提醒"
          desc="记录认证、入口与安全相关的官方更新。入口状态如有变化会在此第一时间说明，请留意时间节点。"
        />

        <div className="mt-8 md:mt-10">
          <ol className="relative ml-2 space-y-0 border-l border-background-200 md:ml-4">
            {timeline.map((item) => (
              <li key={item.date} className="relative pb-6 pl-7 md:pl-9 last:pb-0">
                <span className="absolute -left-[7px] top-1.5 flex h-3.5 w-3.5 items-center justify-center rounded-full border-2 border-background-50 bg-primary-500 ring-1 ring-primary-200"></span>
                <div className="flex flex-col gap-1.5 rounded-lg border border-background-200 bg-background-100/60 p-4 transition-colors hover:border-primary-200 md:p-5">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className={"inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium " + item.tagColor}>
                      {item.tag}
                    </span>
                    <span className="font-display text-xs tracking-wide text-secondary-500 md:text-sm">{item.date}</span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 md:text-base">{item.title}</h3>
                  <p className="text-xs leading-relaxed text-foreground-600 md:text-sm">{item.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}